const answerTypes = {
  BooleanAnswer: {
    name: "Логический",
    componentName: "AppBooleanAnswer",
    type: "boolean"
  },
  MultipleItemsAnswer: {
    name: "Несколько из списка",
    componentName: "AppMultipleItemsAnswer",
    type: "multipleItems"
  },
  SingleItemAnswer: {
    name: "Переключатели",
    componentName: "AppSingleItemAnswer",
    type: "singleItem"
  },
  IntegerAnswer: {
    name: "Число",
    componentName: "AppIntegerAnswer",
    type: "integer"
  }
};

const constants = {
  answerTypes
};

export default constants;
